import React from 'react';
import { Table, Dropdown } from 'semantic-ui-react';

const ListRow = actionHandler => badgingBlacklist => {
  const rowMenuOptions = [
    { key: 1, text: 'Edit', value: 'Edit' },
    { key: 2, text: 'Delete', value: 'Delete' },
  ];

  const {
    id,
    vin,
    sellerNumber,
    expirationDate,
    notes,
    createdAt,
    status,
  } = badgingBlacklist;

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, badgingBlacklist);
  };

  return (
    <Table.Row key={id}>
      <Table.Cell>{vin}</Table.Cell>
      <Table.Cell>{sellerNumber}</Table.Cell>
      <Table.Cell>{expirationDate}</Table.Cell>
      <Table.Cell>{notes}</Table.Cell>
      <Table.Cell>{status}</Table.Cell>
      <Table.Cell>{createdAt}</Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRow;
